// Mansioni sportive (12/10/2026): solo inquadramenti da lavoratore sportivo (art. 25 D.Lgs. 36/2021
// + mansioni FIPAV). Tenere allineato con backend/src/lib/mansioni.ts.
export const GRUPPI_MANSIONI = [
  ['Art. 25 D.Lgs. 36/2021', ['Allenatore', 'Istruttore', 'Direttore tecnico', 'Direttore sportivo', 'Preparatore atletico', 'Direttore di gara', 'Atleta']],
  ["Pallavolo/beach (FIPAV, rientrano nell'art. 25)", ['Smart coach', 'Team manager', 'Delegato arbitrale', 'Giudice di linea', 'Segnapunti', 'Arbitro formatore', 'Giudice sportivo']],
  ['Pallavolo/beach (decreto Dip. Sport 2024)', ['Tecnico formatore', 'Osservatore', 'Supervisore', 'Scoutman', 'Videoman', 'Dirigente accompagnatore', 'Addetto video-check', 'Designatore ufficiali di gara', 'Tecnico dei materiali e attrezzature']],
];
export const MANSIONI = GRUPPI_MANSIONI.flatMap(([, m]) => m);

// template pertinente: stessa modalità di compenso e pensato per la mansione (nessuna mansione = tutte)
// FISSO_ORE (fisso + ore, 03/11/2026) può usare sia i template a fisso sia quelli a ore
export const tipoTemplateOk = (t, modalita) => modalita === 'FISSO_ORE' || (t.tipo || 'ORARIO') === (modalita || 'ORARIO');
export const templatePertinente = (t, d) =>
  tipoTemplateOk(t, d?.modalita_compenso) && (!t.ruoli?.length || t.ruoli.includes(d?.ruolo_descrizione));

// <select> della mansione: gruppi ufficiali; un valore vecchio non in elenco resta visibile finché non lo si cambia
export function SelectMansione({ value, onChange, style }) {
  return (
    <select style={style} value={value || ''} onChange={e => onChange(e.target.value)}>
      {!value && <option value="">— scegli la mansione —</option>}
      {value && !MANSIONI.includes(value) && <option value={value}>{value} (vecchio valore, non in elenco: cambialo)</option>}
      {GRUPPI_MANSIONI.map(([g, voci]) => (
        <optgroup key={g} label={g}>{voci.map(m => <option key={m} value={m}>{m}</option>)}</optgroup>
      ))}
    </select>
  );
}
